export const FEED_VIEW_MODES = ['card', 'list'];
export const DEFAULT_FEED_VIEW_MODE = 'card';
/** Compact feed typography (phones). */
export const DISCUSSION_FEED_COMPACT_MQ = '(max-width: 960px)';
/** Posts shell drawer + mobile chrome (phones ≤960px). */
export const POSTS_SHELL_COMPACT_MQ = '(max-width: 960px)';
/** Tablet + phone: off-canvas nav drawer (persistent sidebar hidden). */
export const POSTS_SHELL_DRAWER_MQ = '(max-width: 1080px)';
/** Tablet-only layout tweaks. */
export const POSTS_SHELL_TABLET_MQ = '(min-width: 961px) and (max-width: 1080px)';

/** Posts shell mobile layout — same breakpoint as compact feed (≤960px). */
export function isDiscussionCompactViewport() {
  return typeof window !== 'undefined' && window.matchMedia(DISCUSSION_FEED_COMPACT_MQ).matches;
}

export function isPostsShellCompactViewport() {
  return typeof window !== 'undefined' && window.matchMedia(POSTS_SHELL_COMPACT_MQ).matches;
}

export function isPostsShellTabletViewport() {
  return typeof window !== 'undefined' && window.matchMedia(POSTS_SHELL_TABLET_MQ).matches;
}

export function isPostsShellDrawerViewport() {
  return typeof window !== 'undefined' && window.matchMedia(POSTS_SHELL_DRAWER_MQ).matches;
}

export function normalizeFeedViewMode(mode) {
  const m = String(mode || '').trim();
  if (m === 'modern') return 'card';
  return FEED_VIEW_MODES.includes(m) ? m : DEFAULT_FEED_VIEW_MODE;
}

export function resolveFeedViewModeForViewport(mode) {
  return normalizeFeedViewMode(mode);
}
